import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import WebsiteProject from '@/features/components/MyProjects/WebsiteProject.vue';
import PovoProject from '@/features/components/MyProjects/PovoProject.vue';
import FinalFantasyProject from '@/features/components/MyProjects/FinalFantasyProject.vue';
import ClimbingHoldClassifier from '@/features/components/MyProjects/ClimbingHoldClassifier.vue';
import EagleProject from '@/features/components/MyProjects/EagleProject.vue';
import ArtHuddleProject from '@/features/components/MyProjects/ArtHuddleProject.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'MyProjects',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ClimbingHoldClassifier),
    _createVNode(ArtHuddleProject),
    _createVNode(WebsiteProject),
    _createVNode(PovoProject),
    _createVNode(FinalFantasyProject),
    _createVNode(EagleProject)
  ]))
}
}

})